import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMoney, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './transactionpayment-model';  //editable..
import TransactionModel from '../transaction/transaction-model';
import PaymenttypePicklist from '../paymenttype/paymenttype-picklist.component';
import BaseList from '../base/base-list.component';
import PaymenttypeModel from '../paymenttype/paymenttype-model';
                
interface IProps { 
    history: History;
    transactionId?: number;
    save?: boolean;
    onSave?: (data: any) =>void;
    onError?: (data: any) =>void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    save: boolean;
}

export default class TransactionpaymentCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private historyState: any = this.props.history.location.state;
    
    private onLoadTransaction = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'transaction': data?.id, 'transactionCaption': data?.name || '', 'value': data.total }  });
    }
   
    private onLoadPaymenttype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'paymenttype': data?.id, 'paymenttypeCaption': data?.name || '' }  });
    }

    private onLoadAllPaymenttype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'paymenttype': data?.[0]?.id, 'paymenttypeCaption': data?.[0]?.name || '' }  });
    }

    private onError = (data: any) => {
        if (data) {
            this.setState({errors: data, save: false});
            this.props.onError?.(data)
        }
    }
    
    private onSave = (data: any) => {
        this.setState({save: false});
        this.props.onSave?.(data)
    }

    private onChange(fieldName: string, value?: string) { 
        
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, 
            }
        }
        this.setState(nextState);

    }

    public componentDidMount(): void {        
        this.onLoadTransaction({'id': this.historyState?.id});
    }

    public componentDidUpdate() {
        if (this.props.save && this.props.save !== this.state.save && this.props.transactionId && this.state.datarow.paymenttype)
            this.setState({datarow: {...this.state.datarow, 'transaction': this.props.transactionId}, save: true});
    }

    render() {
        return (
            //editable..
            <>
            {this.historyState?.id > 0 &&
            <BaseView history={this.props.history} caption=''
                model={TransactionModel} onLoad={this.onLoadTransaction}/>
            }         
            <BaseCreate history={this.props.history} caption={this.props.disableView? ' ' : ''} buttonCaption={this.props.disableView? ' ' : ''}
                model={Model} datarow={this.state.datarow} onError={this.onError} save={this.state.save} onSave={this.onSave} disableAutoBack={this.props.disableView} disableBackButton={this.props.disableView} disableCard={this.props.disableView}>
                
                {this.props.disableView ?
                <BaseList history={this.props.history} caption=' ' model={PaymenttypeModel} endPointFilter={PaymenttypeModel.endPointFilterList()} onLoadAll={this.onLoadAllPaymenttype} disableView/>
                
                :
                <>
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputDate name='paymentdate' label='Date' value={this.state.datarow.paymentdate} error={this.state.errors?.paymentdate} onChange={this.onChange} />
                <InputPicklist name='paymenttype' label='Type' value={this.state.datarow.paymenttype} caption={this.state.datarow.paymenttypeCaption} error={this.state.errors?.paymenttype} onChange={this.onChange} >
                    <PaymenttypePicklist currentId={this.state.datarow.paymenttype} onLoad={this.onLoadPaymenttype}/>
                </InputPicklist>                 
                <InputMoney name='value' label='Payment' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                </>
                }
            </BaseCreate>
            </>
        );
    }     
     
}